import { render } from "./withdrawalBalance.vue?vue&type=template&id=6573dc29&scoped=true"
import script from "./withdrawalBalance.vue?vue&type=script&lang=js"
export * from "./withdrawalBalance.vue?vue&type=script&lang=js"

import "./withdrawalBalance.vue?vue&type=style&index=0&id=6573dc29&scoped=true&lang=css"
import "./withdrawalBalance.vue?vue&type=style&index=1&id=6573dc29&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6573dc29"]])

export default __exports__